import { Flex, Text } from "@chakra-ui/react";
import { useMemo } from "react";

interface Props {
  number: number;
  decimals?: number;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
}
export function FixedNumberDisplay({
  number,
  decimals = 0,
  prefix = null,
  suffix = null,
}: Props) {
  const value = number ?? 0;

  const formattedNumber = useMemo(
    () =>
      value.toLocaleString(document.documentElement.lang, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }),
    [value, decimals],
  );

  return (
    <Flex alignItems="center" display="inline-flex" gap={1}>
      {typeof prefix === "object" ? prefix : <Text>{prefix}</Text>}
      <Text>{formattedNumber}</Text>
      {typeof suffix === "object" ? suffix : <Text>{suffix}</Text>}
    </Flex>
  );
}
